import { Outlet } from 'react-router';
import styles from './auth-layout.module.css';

export function AuthLayout() {
  return (
    <div className={`flex h-screen w-screen justify-center items-center ${styles.background}`}>
      <Outlet />
    </div>
  );
}
